/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DiscogsReleaseTracklistTracksInner } from './DiscogsReleaseTracklistTracksInner';
import {
    DiscogsReleaseTracklistTracksInnerFromJSON,
    DiscogsReleaseTracklistTracksInnerFromJSONTyped,
    DiscogsReleaseTracklistTracksInnerToJSON,
} from './DiscogsReleaseTracklistTracksInner';

/**
 * 
 * @export
 * @interface DiscogsReleaseTracklist
 */
export interface DiscogsReleaseTracklist {
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklist
     */
    releaseId: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklist
     */
    title: string;
    /**
     * Discogs' `artists_sort`, for the operator to confirm the release.
     * @type {string}
     * @memberof DiscogsReleaseTracklist
     */
    artist: string;
    /**
     * 
     * @type {Array<DiscogsReleaseTracklistTracksInner>}
     * @memberof DiscogsReleaseTracklist
     */
    tracks: Array<DiscogsReleaseTracklistTracksInner>;
}

/**
 * Check if a given object implements the DiscogsReleaseTracklist interface.
 */
export function instanceOfDiscogsReleaseTracklist(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "artist" in value;
    isInstance = isInstance && "tracks" in value;

    return isInstance;
}

export function DiscogsReleaseTracklistFromJSON(json: any): DiscogsReleaseTracklist {
    return DiscogsReleaseTracklistFromJSONTyped(json, false);
}

export function DiscogsReleaseTracklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsReleaseTracklist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': json['release_id'],
        'title': json['title'],
        'artist': json['artist'],
        'tracks': ((json['tracks'] as Array<any>).map(DiscogsReleaseTracklistTracksInnerFromJSON)),
    };
}

export function DiscogsReleaseTracklistToJSON(value?: DiscogsReleaseTracklist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'title': value.title,
        'artist': value.artist,
        'tracks': ((value.tracks as Array<any>).map(DiscogsReleaseTracklistTracksInnerToJSON)),
    };
}

